import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericFilter } from '../models/GenericFilter';
import { MigratedLegacyProjectDto, LegacyProjectToMigrateDto } from '../models/LegacyProjectToMigrateDto';
import { LegacySquirrelUserDto, Sq3IdPairDto } from '../models/LegacySquirrelUser';
import { SquirrelEnvironmentDto } from '../models/SquirrelEnvironmentDto';
import { BaseService } from './base.service';
import { OAuthServiceService } from './o-auth-service.service';
import { TenantService } from './tenant.service';

@Injectable({ providedIn: 'root' })
export class DatabaseMigrationService extends BaseService { 
  
  constructor(private httpClient: HttpClient,
    private oauthService: OAuthServiceService,
    private tenantService: TenantService
    ) {
    super();
  }

  // Requests mit User Token
  getCurrentVersion(): Observable<number> {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
    console.log("-----------> database-migration service headers = ", headers)
    return this.httpClient.get<number>(`${this.databaseMigrations}/GetCurrentVersion`, { headers: headers });
  }
  getSquirrelEnvironments(genericFilter:GenericFilter) : Observable<SquirrelEnvironmentDto[]> {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
    return this.httpClient.post<SquirrelEnvironmentDto[]>(`${this.databaseMigrations}/SquirrelEnvironments`, genericFilter, { headers: headers });
  }
  migrateLegacySquirrelUsers(selectedEnvironment:string, selectedTenant: string, tenantId: string, userDtos:LegacySquirrelUserDto[]) : Observable<any> { 
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
    return this.httpClient.post<any>(`${this.account}/MigratedSquirrelUsers?selectedEnvironment=${selectedEnvironment}&selectedTenant=${selectedTenant}&tenantId=${tenantId}`, userDtos, { headers: headers });
  }

  createSquirrelEnvironment(environmentDto: SquirrelEnvironmentDto) : Observable<SquirrelEnvironmentDto> {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
    return this.httpClient.post<SquirrelEnvironmentDto>(`${this.databaseMigrations}/SquirrelEnvironment`, environmentDto, { headers: headers });
  }
  updateSquirrelEnvironment(environmentDto: SquirrelEnvironmentDto) : Observable<any> { 
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
    return this.httpClient.put<any>(`${this.databaseMigrations}/UpdateSquirrelEnvironment`, environmentDto, { headers: headers });
  }

  deleteSquirrelEnvironment(envId: any) :Observable<any> { 
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
    return this.httpClient.delete<any>(`${this.databaseMigrations}/${envId}/DeleteSquirrelEnvironment`, { headers: headers });
  } 


  // Requests mit Application Token

  migrateLegacySquirrelProjects(selectedEnvironment:string, selectedTenant: string, legacyProjectToMigrateDtos: LegacyProjectToMigrateDto[]) : Observable<any>{
    var self = this;
    return new Observable<any>((subscriber)=>{
      self.tenantService.getToken(selectedTenant).subscribe({
        next: (token) => {
          self.tenantService.storeToken(token);
          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
          self.httpClient.put<any>(`${this.tenantProjects}/AddMigratedProjects/${selectedTenant}`, legacyProjectToMigrateDtos, { headers: headers }).subscribe ({
            next:(project) => {
              subscriber.next(project);
            },
            complete:() => {
              subscriber.complete();
            },
            error: (error: any) => {
              subscriber.error(error);
            }
          });
      },
        error: (error: any) => {
          subscriber.error(error);
        }
      })
    });

    // const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
    // return this.httpClient.put<any>(`${this.tenantProjects}/AddMigratedProjects/${selectedTenant}`, legacyProjectToMigrateDtos, { headers: headers });
  }

  // other requests (noch nicht zugeordnet)
  executeGenericDbsQueries() {
    return this.httpClient.get(`${this.databaseMigrations}/ExecuteGenericDbsQueries`);
  }

  executeMainDbSqlQueries() {
    return this.httpClient.get(`${this.databaseMigrations}/ExecuteMainDbSqlQueries`);
  }

  // migrateLegacySquirrelUserz(userDtos:LegacySquirrelUserDto[]) : Observable<any> {
  //   return this.httpClient.post<any>(`${this.account}/MigratedSquirrelUsers`, userDtos);
  // }

  getMigratedUsers(selectedEnvironment:string) : Observable<Sq3IdPairDto[]> {
    return this.httpClient.get<Sq3IdPairDto[]>(`${this.account}/GetMigratedSquirrelUsers?selectedEnvironment=${selectedEnvironment}`);
  }

  // migrateLegacySquirrelProjects(selectedEnvironment:string,legacyProjectToMigrateDtos: LegacyProjectToMigrateDto[]) : Observable<any>{
  //   return this.httpClient.post<any>(`${this.projects}/LegacySquirrelProjects?selectedEnvironment=${selectedEnvironment}`, legacyProjectToMigrateDtos);
  // }

  getMigratedProjects() : Observable<MigratedLegacyProjectDto[]> {
    return this.httpClient.get<MigratedLegacyProjectDto[]>(`${this.projects}/GetLegacySquirrelProjects`);    
  }

  test(): Observable<LegacySquirrelUserDto> {
    return this.httpClient.get<LegacySquirrelUserDto>(`${this.account}/TestUsers`);
  }

  SendMail(environment: string) : Observable<any> { 
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
    return this.httpClient.get<any>(`${this.databaseMigrations}/SendEmail?environment=${environment}`, { headers: headers });
  }

  getEmailDataCount(environment: string) : Observable<number> {
    return this.httpClient.get<number>(`${this.databaseMigrations}/EmailDataCount?environment=${environment}`);
  }
}
